import { render, staticRenderFns } from "./SelectRegions.vue?vue&type=template&id=8ea3a10e"
import script from "./SelectRegions.vue?vue&type=script&lang=js"
export * from "./SelectRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports